export { default } from "./Bage"
